import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductBanner = _resolveComponent("ProductBanner")!
  const _component_ProductWorth = _resolveComponent("ProductWorth")!
  const _component_ProductContrast = _resolveComponent("ProductContrast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProductBanner),
    _createVNode(_component_ProductWorth, {
      step: "advantage",
      title: "核心优势"
    }),
    _createVNode(_component_ProductContrast),
    _createVNode(_component_ProductWorth, {
      step: "framework",
      title: "三维技术架构"
    }),
    _createVNode(_component_ProductWorth, {
      step: "deploy",
      title: "灵活部署模式"
    })
  ], 64 /* STABLE_FRAGMENT */))
}